'use strict';
define('utils/domready',['jquery'], function ($) {
  return function(callback) {
    $(function() {
      window.requestAnimationFrame(callback);
    });
  };
});
